import React from "react";
import Joi from "joi-browser";
import Form from "./common/common";
import { getQuestion, saveQuestion } from "../services/movieService";
import { getGenres } from "../services/geneServie";

class QuestionForm extends Form {
  state = {
    data: { title: "", link: "", genreId: "", rating: "" },
    genres: [],
    errors: {},
  };

  schema = {
    _id: Joi.string(),
    title: Joi.string().required().label("Title"),
    link: Joi.string().required().label("Link"),
    genreId: Joi.string().required().label("Genre"),
    rating: Joi.number().required().min(0).max(10).label("Rating"),
  };

  async populateGenres() {
    const { data: genres } = await getGenres();
    this.setState({ genres });
  }

  async populateMovie() {
    try {
      const questionId = this.props.match.params.id;
      if (questionId === "new") return;
      const { data: movie } = await getQuestion(questionId);
      this.setState({ data: this.mapToViewModel(movie) });
    } catch (ex) {
      if (ex.response && ex.response.status === 404)
        this.props.history.replace("/not-found");
    }
  }

  async componentDidMount() {
    await this.populateGenres();

    await this.populateMovie();
  }

  mapToViewModel(question) {
    return {
      _id: question._id,
      title: question.title,
      genreId: question.genre._id,
      title: question.title,
      rating: question.rating,
    };
  }

  doSubmit = async () => {
    await saveQuestion(this.state.data);

    this.props.history.push("/question");
  };

  render() {
    return (
      <div>
        <h1>Question Form</h1>
        <form onSubmit={this.handleSubmit}>
          {this.renderInput("title", "Title")}
          {this.renderSelect("genreId", "Genre", this.state.genres)}
          {this.renderInput("link", "Link")}
          {this.renderInput("rating", "Rating")}
          {this.renderButton("Save")}
        </form>
      </div>
    );
  }
}

export default QuestionForm;
